import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormBuilder } from 'shared-components/forms/form';
import { RadioGroup } from '../elements-inputs/radio-group';
import Bookings from '../../../api/api-bookings';
import Contracts from '../../../api/api-contracts';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class DeclineUpdateModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      errorText: ''
    };
    this.viewAsHost = 'host' === this.props.viewAs.toLowerCase();
    this.modalBody = this.modalBody.bind(this);
    this.declineUpdateAction = this.declineUpdateAction.bind(this);
    this.declineUpdateActionCb = this.declineUpdateActionCb.bind(this);
  }

  declineUpdateAction (form, cb, refs) {
    const { accessToken, bookingID, currentContracts } = this.props;
    const path = this.viewAsHost ? `${bookingID}/host/update/deny` : `${bookingID}/guest/host_update/deny`;

    if (currentContracts && !isEmpty(currentContracts)) {
      return Contracts.updateGuestUpdate(
        { reason: refs.radio.returnRadioGroupValue() },
        bookingID,
        accessToken,
        'decline',
        cb
      );
    }

    Bookings.updateAction(
      { decline_reason: refs.radio.returnRadioGroupValue() },
      accessToken,
      path,
      cb
    );
  }

  declineUpdateActionCb (response) {
    const { bookingID } = this.props;
    if (200 === response.statusCode) {
      // action for ios webview
      if (this.props.finalCb) {
        this.props.closeIOSModal();
        this.props.finalCb();
        return null;
      }
      this.context.router.push({ pathname: `/inbox/${bookingID}` });
    } else {
      this.setState({
        errorText: this.props.intl.formatMessage({ id: 'inbox_review_booking_update.decline_update_modal.something_wrong', defaultMessage: 'Something went wrong, please try again.' })
      });
    }
  }

  modalBody () {
    const { guestName } = this.props;

    return (
      <div className="decline-update-modal col-xs-12" style={{ paddingBottom: 40 }}>
        { this.viewAsHost
          ? <p className="gutter" data-testing-id="reason-title">
            <FormattedMessage
              id='inbox_review_booking_update.decline_update_modal.declining_request'
              defaultMessage="Tell the guest why you're declining their update request."
            />
          </p> : '' }
        <FormBuilder
          formname="decline-update-form"
          formStyle="modal-plus"
          formInputs={ this.viewAsHost ? [{ custom: () => {
            return (
              <RadioGroup
                isRequired
                ref="radio"
                inputData={[
                  {
                    ID: 'not-available',
                    value: 'My space isn\'t available at that time',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_booking_update.decline_update_modal.space_isnt_available', defaultMessage: 'My space isn\'t available at that time.' })
                  },
                  {
                    ID: 'size',
                    value: 'My space cannot hold that many people',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_booking_update.decline_update_modal.cannot_hold', defaultMessage: 'My space cannot hold that many people.' })
                  },
                  {
                    ID: 'hours',
                    value: 'This request does not meet our min number of hours',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_booking_update.decline_update_modal.min_number', defaultMessage: 'This request does not meet our min number of hours.' })
                  },
                  {
                    ID: 'guest-request',
                    value: 'Guest asked me to decline on their behalf',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_booking_update.decline_update_modal.guest_decline', defaultMessage: 'Guest asked me to decline on their behalf.' })
                  },
                  {
                    ID: 'other',
                    value: '',
                    displayText: this.props.intl.formatMessage({ id: 'inbox_review_booking_update.decline_update_modal.other', defaultMessage: 'Other' }),
                    collectUserInput: true
                  }
                ]}
                groupName="decline-update-reason"
              />);
          } }] : []}
          submitAction={ this.declineUpdateAction }
          submitCallback={ this.declineUpdateActionCb }
          isButtonDisabled={ false }
          buttonText={ this.viewAsHost
            ? this.props.intl.formatMessage({ id: 'inbox_review_booking_update.decline_update_modal.decline', defaultMessage: 'Decline' })
            : this.props.intl.formatMessage({ id: 'inbox_review_booking_update.decline_update_modal.decline_update', defaultMessage: 'Decline Update' })
          }
          errorText={ this.state.errorText }
          beforeCTA={
            <div style={ this.viewAsHost ? {} : { marginBottom: 40 }}>
              <hr style={{ marginTop: 0 }} />
              <p className="text-center">
                { this.viewAsHost
                  ? <span data-testing-id="before-cta-host-view"><FormattedMessage
                    id='inbox_review_booking_update.decline_update_modal.after_decline'
                    defaultMessage="After you decline, your original booking with {name} will still be active."
                    values={{
                      name: guestName
                    }}
                  /></span>
                  : <span data-testing-id="before-cta-guest-view"><FormattedMessage
                    id='inbox_review_booking_update.decline_update_modal.updates_not_applied'
                    defaultMessage="The updates will not be applied and your booking will revert to the original details."
                  /></span>
                }
              </p>
            </div>
          }
        />
      </div>
    );
  }

  render () {
    return (
      <BootstrapModal
        {...this.props}
        addCloseIcon
        show
        modalID="decline-update-modal"
        modalSize="sm-size"
        modalType="standard"
        header={ this.viewAsHost
          ? <h3 data-testing-id="header-host-view"><FormattedMessage id='inbox_review_booking_update.decline_update_modal.decline_update_request' defaultMessage="Decline update request"/></h3>
          : <h4 data-testing-id="header-guest-view"><FormattedMessage id='inbox_review_booking_update.decline_update_modal.sure_decline' defaultMessage="Are you sure you want to decline?"/></h4>
        }
        body={ this.modalBody() }
      />
    );
  }
}


DeclineUpdateModal.propTypes = {
  accessToken: PropTypes.string,
  bookingID: PropTypes.string,
  guestName: PropTypes.string,
  viewAs: PropTypes.string,
  closeIOSModal: PropTypes.func,
  finalCb: PropTypes.func,
  intl: intlShape
};

DeclineUpdateModal.contextTypes = {
  router: PropTypes.object
};

exports.DeclineUpdateModal = injectIntl(DeclineUpdateModal);
